export default (val = '') => `$${val}`;
